import { ComponentStyleConfig, defineStyle } from '@chakra-ui/react'
import { extractInputPlaceholderStyle } from './placeholder-style'

const baseStyle = defineStyle(({ theme }) => {
    const placeholderColor = extractInputPlaceholderStyle(theme as any).color

    return {
        control: {
            height: '33px',
        },
        valueContainer: {
            px: '15px',
            fontSize: '0.6875rem',
            lineHeight: '1.0625rem',
            height: 'full',
        },
        placeholder: {
            color: placeholderColor,
            fontSize: '0.6875rem',
            lineHeight: '1.0625rem',
            isTruncated: true,
        },
        menuList: {
            py: '6px',
        },
        option: {
            p: '6px 18px !important',
            fontSize: '0.6875rem',
            lineHeight: '1.0625rem',
        },
    }
})

const variants = {
    'cycle-number': defineStyle(() => ({
        menu: {
            w: '150px',
        },
        dropdownIndicator: {
            pl: '0px',
            pr: '9px',
            bgColor: 'transparent',
        },
        valueContainer: {
            fontWeight: 400,
            fontSize: '0.6875rem',
            lineHeight: '1.0625rem',
            pl: '9px',
            pr: '5px',
        },
        placeholder: {
            fontSize: '0.6875rem',
            lineHeight: '1.0625rem',
        },
        control: {
            flexWrap: 'unset',
            bgColor: 'transparent',
            borderColor: 'stroke.light',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderRadius: '5px',
            _focusVisible: {
                bgColor: 'unset',
            },
            _hover: {
                bgColor: 'green.transparent_3',
            },
            _active: {
                outline: 'none',
                bgColor: 'bg.green10',
            },
        },
        option: {
            bgColor: 'transparent',
            h: '26px',
            _hover: {
                bgColor: 'green.transparent_3',
            },
            fontSize: '0.6875rem',
            lineHeight: '1.0625rem',
            color: 'green.default',
        },
    })),
    'date-picker': defineStyle(() => ({
        menu: {
            w: '150px',
        },
        dropdownIndicator: {
            p: 0,
            bgColor: 'transparent',
        },
        valueContainer: {
            fontWeight: 500,
            fontSize: '0.6875rem',
            lineHeight: '0.75rem',
            p: 0,
        },
        placeholder: {
            fontSize: '0.6875rem',
            lineHeight: '0.9375rem',
        },
        control: {
            py: 0,
            px: 0,
            h: '15px',
            w: '113px',
            minHeight: '15px',
            bgColor: 'transparent',
            border: 'none',
            _focusVisible: {
                bgColor: 'unset',
            },
            _hover: {
                bgColor: 'green.transparent_3',
            },
            _active: {
                outline: 'none',
                bgColor: 'bg.green10',
            },
        },
        option: {
            bgColor: 'transparent',
            h: '26px',
            _hover: {
                bgColor: 'green.transparent_3',
                color: 'green.default',
            },
            fontSize: '0.6875rem',
            lineHeight: '1.0625rem',
            color: 'green.default',
        },
    })),
}

// This component also uses some styles from Input
export const SelectTheme: ComponentStyleConfig = {
    baseStyle,
    variants,
}
